import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["fields"]

  connect() {
    this.toggle()
  }

  toggle() {
    if (!this.hasFieldsTarget) return
    const checkbox = this.element.querySelector('input[type="checkbox"][name$="[header_as_banner]"]')
    if (!checkbox) return
    this.fieldsTarget.classList.toggle("hidden", !checkbox.checked)
  }
}
